angular.module('aprima-core-ui').directive('apTransitionToMessage',
    ['TransitionToHelper', 'MessageTransitionToHelper',
        function (TransitionToHelper, MessageTransitionToHelper) {
            'use strict';

            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    function getTransitionFromElement() {
                        return MessageTransitionToHelper.getTransitionForMessage(attrs.messageTypeId, attrs.messageId, attrs.messageSubTypeId, attrs.createNew);
                    }

                    TransitionToHelper.registerTransitionTo(scope, element, attrs, getTransitionFromElement);
                }
            };
        }]);
